<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="10"
            md="4"
          >
            <v-card outlined>
              <v-img
                class="mx-auto mt-10"
                max-height="200"
                max-width="200"
                :src="logoB"
              />
              <!-- <div>
                <p class="text-center green--text pt-5 my-0">
                  <v-icon>car</v-icon> Pool
                </p>
              </div> -->
              <v-toolbar
                light
                flat
              >
                <v-spacer />
                <p class="mt-5 mb-0 pb-0 text-center headline">
                  Login
                </p>
                <div class="flex-grow-1" />
              </v-toolbar>
              <v-alert
                class="mx-5 mb-n3"
                v-model="isError"
                type="error"
                dismissible
              >
                {{ this.errorMessage }}
              </v-alert>
              <v-card-text>
                <br>
                <v-form 
                  ref="form" 
                  v-model="valid" 
                  lazy-validation 
                  @submit="login"
                  on-submit="return false;"
                >
                  <v-text-field
                    outlined
                    color="success"
                    label="Username"
                    prepend-icon="mdi-account-circle"
                    v-model="username"
                    :rules="nameRules"
                    required
                    ref="usernameRef"
                    placeholder=" "
                  />

                  <v-text-field
                    outlined
                    v-model="password"
                    :rules="passwordRules"
                    color="success"
                    required
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    prepend-icon="mdi-lock"
                    @keyup.enter="login"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    ref="passwordRef"
                    placeholder=" "
                  />
                  <p style="text-align: right">
                    <a
                      href="#"
                      @click.prevent="forgotPassword"
                    >Forgot password</a>
                  </p>
                </v-form>
                <!-- <div class="heading"><p class="green--text">Forgot Password ?</p></div> -->
              </v-card-text>
              <v-divider />
              <v-card-actions class="pa-4">
                <v-btn
                  block
                  color="#00ACDC"
                  type="submit"
                  form="form"
                  @click="login"
                  :loading="loading"
                  :disabled="loading"
                  class="white--text"
                >
                  Login
                  <template #loader>
                    <span>Loading...</span>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-dialog
          v-model="forgotPasswordPopup"
          max-width="400"
          persistent
        >
          <v-card>
            <v-card-title>
              Forgot password
            </v-card-title>
            <v-card-text>
              <p>Enter your user account email address. We will send you a link to reset your password.</p>
              <v-form
                ref="forgotPasswordForm"
                lazy-validation
                @submit="sendResetPassword"
              >
                <v-text-field
                  outlined
                  label="Email"
                  v-model="resetPasswordEmail"
                  :rules="emailRules"
                  placeholder="Please enter your email address"
                />
                <div />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                @click="cancelResetPassword"
                color="error"
                class="mr-2"
              >
                Cancel
              </v-btn>
              <v-btn
                @click="sendResetPassword"
                type="submit"
                color="success"
                :loading="loadingSendResetPassword"
                :disable="loadingSendResetPassword"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import qs from 'qs'
export default {
  props: {
    source: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    loginText: 'Login',
    showPassword: false,
    valid: true,
    username: "",
    isError: false,
    password: "",
    error: false,
    errorMessage: "",
    passwordRules: [(v) => !!v || "Password is required"],
    nameRules: [(v) => !!v || "Username is required"],
    loader: null,
    loading: false,
    forgotPasswordPopup: false,
    loadingSendResetPassword: false,
    resetPasswordEmail: '',
    emailRules: [
      (v) => !!v || "Email is required",
      (value) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(value) || 'Invalid e-mail.'
      },
    ],
  }),
  computed: {
    logoB() {
      return process.env.VUE_APP_LOGO_B;
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    username() {
      this.isError = false;
    },
    password() {
      this.isError = false;
    },
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.loader = this.loading;

        const payloads = {
          username: this.username,
          password: this.password,
        };
        this.$store.dispatch("LOGIN_USER", payloads).then(() => {
          if (this.$store.state.error == true) {
            this.isError = true;
            this.errorMessage = this.$store.state.errorMsg;

            this.loading = false;
            this.loader = this.loading;
            return;
          }
        });
      }
    },
    forgotPassword() {
      this.forgotPasswordPopup = true
    },
    cancelResetPassword() {
      this.forgotPasswordPopup = false
      this.$refs.forgotPasswordForm.reset();
    },
    sendResetPassword() {
      if (!this.$refs.forgotPasswordForm.validate()) {
        return;
      }
      this.loadingSendResetPassword = true;
      this.$http.post(`${process.env.VUE_APP_API_URL}/send_reset_password`, qs.stringify({ email: this.resetPasswordEmail }))
        .then((resp) => {
          this.cancelResetPassword();
          this.$swal({
            icon: resp.data.data.error ? 'error' : 'success',
            title: resp.data.data.error ? resp.data.data.message : "Please check your inbox/spam. If the email is registered you will get an email to reset your password.",
          });
        }).finally(() => {
          this.loadingSendResetPassword = false;
        });
    },
  }
};
</script>
